import React, { useContext } from 'react';

export const StudioSummaryContext = React.createContext();

export const useStudioSummary = () => useContext(StudioSummaryContext);

export const StudioSummaryModalType = {
	SUMMARY: 'SUMMARY',
};
